import { render, staticRenderFns } from "./labels.vue?vue&type=template&id=0b423063&scoped=true&"
import script from "./labels.vue?vue&type=script&lang=ts&"
export * from "./labels.vue?vue&type=script&lang=ts&"
import style0 from "./labels.vue?vue&type=style&index=0&id=0b423063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b423063",
  null
  
)

export default component.exports